import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import API from '../../../create/api';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { TableHead } from '@mui/material';
import Stats from './stats';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
    '& .MuiTableCell-root': {
      border: '1px solid #e0e0e0',
      padding: '12px 16px',
    },
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiTableCell-root': {
        color: 'white',
        fontWeight: 600,
      },
    },
    '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd)': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
    '& .MuiTableBody-root .MuiTableRow-root:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  createButton: {
    marginBottom: theme.spacing(2),
    padding: '10px 20px',
    fontWeight: 'bold',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  },
  paymentAmount: {
    fontWeight: 'bold',
    color: theme.palette.success.dark,
  },
}));

function PaymentIndex(props: any) {
  const classes = useStyles();
  const history = useHistory();

  // first fetch
  const [rows, setRows]: [any[], any] = useState([]);

  async function fetchAPI() {
    API.getAll(`${process.env.REACT_APP_API_SERVER}/payments?_sort=id:DESC`).then((payments) => {
      setRows(payments);
    });
  }

  useEffect(() => {
    fetchAPI();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stats />
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="payments table" size="medium">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Date</TableCell>
                <TableCell align="left">Company</TableCell>
                <TableCell align="center">Methods</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="left">Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.map((row: any) => (
                  <TableRow
                    key={row.id}
                    onClick={() => {
                      history.push(`/dashboard/paymentshow/${row.id}`);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>
                      <strong>#{row.id}</strong>
                    </TableCell>
                    <TableCell>{moment(row.created_at).format('DD/MMM/YY')}</TableCell>
                    <TableCell align="left">{row.company?.name}</TableCell>
                    <TableCell align="center">
                      <span
                        style={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          backgroundColor: '#e3f2fd',
                          color: '#0d47a1',
                          fontWeight: 500,
                        }}
                      >
                        {row.paymentMethod ?? 'N/A'}
                      </span>
                    </TableCell>
                    <TableCell align="right" className={classes.paymentAmount}>
                      {row.amount?.toLocaleString()}
                    </TableCell>
                    <TableCell align="left">
                      {row.note ? row.note : <em style={{ color: '#9e9e9e' }}>No notes</em>}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" style={{ padding: '30px' }}>
                    <div style={{ color: '#9e9e9e' }}>
                      <div style={{ fontSize: '20px', marginBottom: '10px' }}>No payment records found</div>
                      <div>Try selecting a different company or add a new payment</div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default withRouter(PaymentIndex);
